import { render, staticRenderFns } from "./symbol-switcher.vue?vue&type=template&id=2380049d&"
import script from "./symbol-switcher.vue?vue&type=script&lang=js&"
export * from "./symbol-switcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports